/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
import Socket from './socket-base';
Socket.getWebSocketConstructor = function getWebSocketConstructor() {
    if (typeof WebSocket !== 'undefined') {
        return WebSocket;
    }
    const scope = typeof globalThis !== 'undefined' ? globalThis : undefined;
    return (scope?.WebSocket || scope?.MozWebSocket);
};
export default Socket;
